const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const validBalance = value => typeof value === 'number' && Number.isFinite(value) && value >= 0;

// Display only: never merge this saved total into user.credits, which also
// feeds spending/eligibility checks. Keep its timestamp on partial profiles.
export function captureCreditBalance(user, previous = null, now = Date.now()) {
  if (!user?.id) return null;
  if (!validBalance(user.credits?.totalAvailable)) {
    return previous?.userId === user.id ? previous : null;
  }
  return {
    userId: user.id,
    totalAvailable: user.credits.totalAvailable,
    updatedAt: now,
    resetDate: user.credits.monthlyAllotment?.resetDate ?? null,
  };
}

export function selectLiveCreditBalance(state) {
  const value = state.user?.credits?.totalAvailable;
  return state.token && state.user?.id && state.hasLoadedServerUser && validBalance(value) ? value : null;
}

export function selectSavedCreditBalance(state, now = Date.now()) {
  const saved = state.creditBalanceSnapshot;
  if (!state.token || !state.user?.id || saved?.userId !== state.user.id) return null;
  if (!validBalance(saved.totalAvailable) || !Number.isFinite(saved.updatedAt)) return null;
  const age = now - saved.updatedAt;
  if (age < 0 || age >= MAX_AGE_MS) return null;
  // A monthly reset makes even a recent saved total obsolete.
  if (saved.resetDate && !(new Date(saved.resetDate).getTime() > now)) return null;
  return saved.totalAvailable;
}
